import { render, staticRenderFns } from "./SpecsLeft.vue?vue&type=template&id=e6c89abe&scoped=true&"
import script from "./SpecsLeft.vue?vue&type=script&lang=js&"
export * from "./SpecsLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c89abe",
  null
  
)

export default component.exports